import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function AccoladeModal({
  open,
  onClose,
  onSubmit,
  accoladeRegister,
  errors,
  selectedType,
  dateYear,
  allStateOptions,
  allConferenceOptions,
  classifications,
  loading,
  resetAccolade,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="max-w-xl w-full space-y-4 border bg-white rounded-lg">
          <div className="p-10">
            <DialogTitle className="text-xl uppercase pb-4">
              Add New Accolade
            </DialogTitle>
            <form onSubmit={onSubmit}>
              <div className="my-5">
                <label className="block text-xs font-bold uppercase mb-2">
                  Select Type
                </label>
                <div className="flex gap-6 text-sm">
                  <label>
                    <input
                      type="radio"
                      value="ALL_STATE"
                      {...accoladeRegister("accoladeType", { required: true })}
                    />{" "}
                    All State
                  </label>
                  <label>
                    <input
                      type="radio"
                      value="ALL_CONFERENCE"
                      {...accoladeRegister("accoladeType", { required: true })}
                    />{" "}
                    All Conference / Region
                  </label>
                  <label>
                    <input
                      type="radio"
                      value="OTHER"
                      {...accoladeRegister("accoladeType", { required: true })}
                    />{" "}
                    Other
                  </label>
                </div>
              </div>

              {selectedType !== "OTHER" && (
                <div className="mb-6">
                  <label className="block text-xs font-bold uppercase mb-2">
                    Description
                  </label>
                  <select
                    {...accoladeRegister("accoladeDescription", {
                      validate: (value) =>
                        selectedType === "OTHER" ||
                        !!value ||
                        "Description is required",
                    })}
                    className="w-full border border-gray-300 rounded p-3"
                  >
                    <option value="">Select description</option>
                    {(selectedType === "ALL_STATE"
                      ? allStateOptions
                      : allConferenceOptions
                    ).map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                  {errors.accoladeDescription && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.accoladeDescription.message}
                    </p>
                  )}
                </div>
              )}

              <div className="mb-6">
                <label className="block text-xs font-bold uppercase mb-2">
                  Classification
                </label>
                <select
                  {...accoladeRegister("accoladeClassification", {
                    required: "Classification is required",
                  })}
                  className="w-full border border-gray-300 rounded p-3"
                >
                  <option value="">Select classification</option>
                  {classifications.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
                {errors.accoladeClassification && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.accoladeClassification.message}
                  </p>
                )}
              </div>

              <div className="mb-4">
                <label className="block text-xs font-bold uppercase mb-2">
                  Year
                </label>
                <input
                  type="number"
                  min={2000}
                  max={dateYear}
                  {...accoladeRegister("accoladeYear", {
                    required: "Year is required",
                  })}
                  className="w-full border border-gray-300 rounded p-3"
                />
                {errors.accoladeYear && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.accoladeYear.message}
                  </p>
                )}
              </div>

              {selectedType === "OTHER" && (
                <div className="mb-6">
                  <label className="block text-xs font-bold uppercase mb-2">
                    Description
                  </label>
                  <textarea
                    {...accoladeRegister("accoladeDescription", {
                      validate: (value) =>
                        selectedType !== "OTHER" ||
                        !!value ||
                        "Description is required",
                    })}
                    className="w-full border border-gray-300 rounded p-3"
                    rows={3}
                    placeholder="Enter description"
                  />
                  {errors.accoladeDescription && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.accoladeDescription.message}
                    </p>
                  )}
                </div>
              )}

              {loading && <LoadingSpinner />}

              <div className="flex gap-4 sm:flex-row-reverse pt-4">
                <button
                  type="submit"
                  className="bg-red-500 text-white px-8 py-3 rounded-md uppercase text-sm hover:bg-red-700"
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => {
                    onClose();
                    resetAccolade();
                  }}
                  className="text-gray-600 hover:text-gray-800"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
